import { render } from "./orphaned-images.vue?vue&type=template&id=cf5d36bc"
import script from "./orphaned-images.vue?vue&type=script&lang=js"
export * from "./orphaned-images.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__